import React, { FC, useEffect, useState } from "react";
import { Button, Col, Divider, Form, Input, notification, Radio, Row } from "antd";
import { useTranslation } from "react-i18next";
import {
  ITerminalPRMRInfoOnusCfg,
  saveTerminalPrmInfoOnusCfg,
  terminalPrmInfoOnusCfg
} from "../../../services/onus/onus";

interface IProps {
  terminalId: string;
}

export const TerminalPrmOnus: FC<IProps> = ({ terminalId }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [formValues, setFormValues] = useState<ITerminalPRMRInfoOnusCfg>();
  const [btnLoading, setBtnLoading] = useState<boolean>(false);
  useEffect(
    function () {
      if (terminalId !== "") {
        terminalPrmInfoOnusCfg({ terminal_id: terminalId }).then((res) => {
          if (res.status === 0) {
            setFormValues(res.data);
            form.setFieldsValue(res.data);
          }
        });
      }
    },
    [terminalId]
  );
  const saveForm = (values) => {
    if (formValues === undefined) {
      return;
    }
    setBtnLoading(true);
    saveTerminalPrmInfoOnusCfg({
      id: formValues["id"],
      terminalId: terminalId,
      onus: values["onus"],
    })
      .then((res) => {
        if (res.status === 0) {
          notification.success({
            message: "save success",
          });
        }
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };
  return (
    <Row gutter={10} style={{ marginTop: "20px" }} hidden={terminalId === ""}>
      <div className="form-content-container-content">
        <Form layout="vertical" form={form} initialValues={formValues} onFinish={saveForm}>
          <Row gutter={30}>
            <Col flex="300px">
              <Form.Item label={t("form.DeviceCode")} name={["onus", "DeviceCode"]}>
                <Input />
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t("form.AuthToken")} name={["onus", "AuthToken"]}>
                <Input />
              </Form.Item>
            </Col>
            <Col flex="300px">
              <Form.Item label={t("form.Url")} name={["onus", "Url"]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Divider />
        <div>
          <Button
            type="primary"
            shape="round"
            style={{ width: "200px", float: "right" }}
            htmlType="submit"
            loading={btnLoading}
            onClick={() => form.submit()}
          >
            {t("button.save")}
          </Button>
        </div>
      </div>
    </Row>
  );
};
